<div class="modal fade" id="modalMessageZalo" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalToggleLabel">CÀI ĐẶT TIN NHẮN</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body col-sm-12 d-flex flex-column">
                <div class="col-sm-12 d-flex gap-3">
                    <div class="col-sm-3">Tên tin nhắn</div>
                    <div class="col-sm-8">{{messageDetail.name.value ?? ''}}</div>
                </div>
                <div class="col-sm-12 d-flex gap-3">
                    <div class="col-sm-3">Mô tả</div>
                    <div class="col-sm-8">{{messageDetail.description.value ?? ''}}</div>
                </div>
                <div class="col-sm-12 d-flex gap-3">
                    <div class="col-sm-12">
                        <InputTextareaNormal
                                :label="messageDetail.content.label"
                                :id="messageDetail.content.id"
                                :placeholder="messageDetail.content.placeholder"
                                :value-default="messageDetail.content.value"
                                @inputValue="onChange($event, messageDetail.content.id)"
                                :error-text="messageDetail.content.error"
                                :is-error="messageDetail.content.isError"
                                :disabled="messageDetail.content.disabled"
                        ></InputTextareaNormal>
                    </div>
                </div>
                <div class="col-sm-12 d-flex gap-3" v-for="variable in messageDetail.variables.value" :key="variable.key">
                    <div class="col-sm-8">
                        <InputTextNormal
                                :label="variable.label"
                                :id="variable.key"
                                :placeholder="variable.placeholder ?? variable.label"
                                :value-default="variable.value"
                                @inputValue="onChange($event, variable.id)"
                                :error-text="variable.error"
                                :is-error="variable.isError"
                                :disabled="variable.disabled ?? true"
                        ></InputTextNormal>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>